import './App.css'

import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Home from './Content/Home/Home'

function App() {

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route
            path="/"
            element={
                <Home />
            }
          />
        </Routes>
      </div>
    </Router>
  )
}

export default App
